import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Anchor00 from './C18Anchor00'
import C18CustomSelect01 from './C18CustomSelect01'
import config from '../../components/utils/config'
import {wsTrans,sensorIds,getUId,doGetPostBasic,makeOpts, hasGatewayType1800, isHydroRoot16} from '../utils/utils'
import {loadSitesInfo,loadZonesInfo,loadGatewaysInfo,getZoneInfo,loadSiteData,getSiteName,getZoneName,privs,loadPrivsInfo,makeSettingsInfo,
  getSuperUserFlags,acctFeature,getGroupInfo} from './C18utils'
import {cl,constant,globs,isHydroR,isPearlFwAtLeast} from '../../components/utils/utils';
import {getZoneControllers} from '../../components/utils/http';


class C18Settings00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
//     props.parms.newProps(this.newProps)// register newProps function
    this.state={
      selController:0,
      loaded:false,
      isLoadingSettings:false,
    }
//     cl(globs.userData.winSize)
    

//     if(acctFeature("videoTest")){
//       this.settingsInfo.account.push(
//         {name: "Video Test", mode: "usa", url: "/usa/c18/admin/vidTest"}
//       )
//     }
//     cl(this.settingsInfo.account)
    this.loadInfo()
  }

  loadInfo=async()=>{
    let pa=this.props.parms
//     cl("loadInfo")
    this.setBreadcrumbs(this.props.parms.settingsType)
    this.setNotify()
    await this.checkSensorPage()
//     cl("back")
    await this.setSitenZoneforAdminPages()
//     cl(this.zoneInfo)
    this.settingsInfo=makeSettingsInfo(this.props,this.zoneInfo,pa.fwVersion)
//     cl(this.settingsInfo.zone_configuration[4])
    this.setState({loaded:true})
    
  }

  setSitenZoneforAdminPages=()=>{
    let si=globs.sitesInfo.info
    let zi=globs.zonesInfo.info
    this.siteId=si[0]?.siteId||""
   
      for(let i=0;i<zi.length;i++){
        let z=zi[i]
        if(z.siteId==this.siteId){ 
          this.zoneId=z.zoneId; break; }
      }

  }
  
  checkSensorPage=async()=>{
//     cl(this.props.parms.settingsType)
    if(["equipment1800","equipment1900","sensor1800","sensor1900","sensor800","sensor3200","sensor3300","mapping","calibration","zone_configuration",]
      .includes(this.props.parms.settingsType)){
//     if(this.props.parms.settingsType=="sensor1800"){
//       cl(this.props.parms.zone)
      await loadZonesInfo()
      await loadGatewaysInfo()
      await loadSiteData(this.props.parms.site)
      var gi
      if(acctFeature("zoneGroups")){
        gi=getGroupInfo(globs.userData.session.groupId)
      }
      let zoneId=(gi)?gi.zones[0]:this.props.parms.zone
      this.zoneInfo=getZoneInfo(zoneId)
      this.isHydroRoot = isHydroR(this.zoneInfo?.gatewayId) || isHydroRoot16(this.zoneInfo?.zoneId)
//       cl("this dot zone",this.zoneInfo?.gatewayId)
      this.isNewPearl = isPearlFwAtLeast(this.zoneInfo?.gatewayId, [1, 18, 2])
//       cl("is new pearl?", this.isNewPearl)
//       cl("is hydro root?", this.isHydroRoot)
//       cl(this.zoneInfo)
      let zInd=this.zoneInfo.siteZoneIndex
//       cl(zInd)
      this.zoneControllers=getZoneControllers(zInd)
      return
    }
    
  }
  
  newUrl=(msg)=>{
//     cl(msg)
    if(msg.cmd=="settingsType"){
      this.setBreadcrumbs(msg.data)
    }
  }
  
  setNotify=()=>{// called from constructor
    this.props.notify({id: "newUrl", func: this.newUrl})
  }
  
  componentWillUnmount=()=>{
    this.props.notify({id: "newUrl", func: this.newUrl, unMount: true})
  }
  
  setBreadcrumbs=async(settingsType)=>{
//     cl("set bread")
    var gi
    if(acctFeature("zoneGroups")){
      gi=getGroupInfo(globs.userData.session.groupId)
    }
    let zoneId=(gi)?gi.groupId:this.props.parms.zone
    let baseUrl=`/usa/c18/sites/${this.props.parms.site}/zones/${zoneId}`
    await loadSitesInfo()
    await loadZonesInfo()
    await loadPrivsInfo()
    let siteName=getSiteName(this.props.parms.site)
    let zoneName=(gi)?gi.name:getZoneName(this.props.parms.zone)
    let gwZoneId=(gi)?gi.zones[0]:this.props.parms.zone
    let gwType=getZoneInfo(gwZoneId)?.gatewayType||1800

//     cl(gi)
//     let zoneEntry=(gi)?
//     {t:gi.name,
//         url:`/usa/c18/sites/${this.props.parms.site}/zones/${gi.groupId}`}:
//     {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`}
    let bc= [
      {t:"Sites", url:"/usa/c18/sites"},
      {t:siteName, name:true, url:`/usa/c18/sites/${this.props.parms.site}`},
//       zoneEntry,
      {t:zoneName, name:true, url:`/usa/c18/sites/${this.props.parms.site}/zones/${zoneId}`},
    ]
//     cl(bc)
//     let baseUrl=`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`
//     let bc=[
//               {t:"Sites", url:"/usa/c18/sites"},
//               {t:"San Diego", url:`/usa/c18/sites/${this.props.parms.site}`},
//               {t:"Greenhouse 02", url:baseUrl},
//             ]
    let ss={t:"Sensor Settings", url:`${baseUrl}/settings/sensor${gwType}`}
    let es={t:"Equipment Settings", url:`${baseUrl}/settings/equipment${gwType}`}
//     cl(settingsType)
//     cl(baseUrl)
    switch (settingsType){
      case "sensor1800":
        bc.push(
          {t:zoneName, name:true, suffix:" Sensor Settings", url:`${baseUrl}/settings/sensor1800`}
        )
        break
      case "sensor1900":
        bc.push(
          {t:zoneName, name:true, suffix:" Sensor Settings", url:`${baseUrl}/settings/sensor1900`}
        )
          break
      case "equipment1800":
        bc.push(
          {t:zoneName, name:true, suffix:" Equipment Settings", url:`${baseUrl}/settings/equipment1800`}
        )
        break
      case "equipment1900":
        bc.push(
          {t:zoneName, name:true, suffix:" Equipment Settings", url:`${baseUrl}/settings/equipment1900`}
        )
          break
      case "account":
        bc=[
          {t:"Sites", url:"/usa/c18/sites"},
          {t:"Admin Settings", url:`/usa/c18/admin`}
        ]
        break
      case "calibration":
        bc.push(
          ss,
          {t:"Calibration", url:`${baseUrl}/settings/calibration`}
        )
        break
      case "setpoints":
        bc.push(
          ss,
          {t:"Setpoints", url:`${baseUrl}/settings/setpoints`}
        )
        break
      case "mapping":
        bc.push(
          ss,
          {t:"Input Mapping", url:`${baseUrl}/settings/mapping`}
        )
        break
      case "syncStatus":
        bc.push(
          ss,
          {t:"Input Mapping", url:`${baseUrl}/settings/syncStatus`}
        )
        break
      case "tankCalibration":
        bc.push(
          ss,
          {t:"Calibration", url:`${baseUrl}/settings/calibration`},
          {t:"Tank Calibration", url:`${baseUrl}/settings/calibration`},
        )
        break
      case "tankMapping":
        bc.push(
          ss,
          {t:"Mapping", url:`${baseUrl}/settings/mapping`},
          {t:"Tank Mapping", url:`${baseUrl}/settings/mapping`},
        )
        break
      case "zone_configuration":
        bc.push(
          es,
          {t:"Zone Configuration", url:`${baseUrl}/settings/zone_configuration`}
        )
        break
      case "sensor800":
        bc.push(
//           ss,
          {t:"Sensor Settings", url:`${baseUrl}/settings/sensor800`}
        )
        break
      case "equipment800":
        bc.push(
          {t:"Equipment Settings", url:`${baseUrl}/settings/equipment800`}
        )
        break
      default:
        break
    }
//     cl(bc)
//     cl("bread")
    this.props.parms.onChange(
      {
        cmd: "breadcrumbs",
        data:{breadcrumbs: bc}
      },
    )
//     cl(bc)
//     cl(bc[bc.length-1].t)
    let lastEntry=bc[bc.length-1]
    let fullTitle=`${lastEntry.t}${lastEntry.suffix||""}`
    this.props.parms.onChange(
      {
        cmd: "pageTitle",
        data:{
          pageTitle: fullTitle,
          pageTitleName: lastEntry.name?lastEntry.t:"",
          pageTitleSuffix: lastEntry.name?(lastEntry.suffix||""):fullTitle,
        }
      },
    )
  }
  
//   newProps=()=>{
//     cl("new props")
//   }


  copyLink4Greenhouse=async()=>{
    let st=this.state
    cl(st)
    cl(globs.userData.session.siteId)
    cl("copy greenhouse")
    let res=await wsTrans("usa", {cmd: "cRest", uri: '/s/iGrow800Acct',
      method: 'retrieve', sessionId: globs.userData.session.sessionId,
      body: {igAccountId:74,siteId:globs.userData.session.siteId,
        controllerType:1}})
    cl(res)
  }

  settingsClick = (e,mode, url) => {
// if this is loading another settings page, we have to update the breadcrumbs *now*
    // pass info into onChange
//     cl([mode, url])
    e.preventDefault()
    let parms=this.props.parms
//     cl(mode,url)
    if(url=="/usa/c18/admin/link4Greenhouse"){return this.copyLink4Greenhouse()}
    
    this.setState({isLoadingSettings:true})
    
    if(mode=="settings"){
//       cl("update bread: ")
      this.setBreadcrumbs(url.substring(1))
    }
    this.props.parms.onChange(
      {
        cmd:"setUrl",
        data:{site: parms.site, zone: parms.zone, mode: mode, url: url, 
          controllerSel:parms.controllerSel},
      },
    )
    // since data will be updated, page will reload?
  }

  removeForGroups=(config)=>{
    let skipNames=["Select Sensors","Sync Status","Cameras","Crop Recipes",
      "Aux Controls",/*"Save & Restore Settings",*/"Pearl Mapping","Pearl Input Config",
      "Auto Setup"]
    if(globs.userData.session.groupId){
      config=config.filter(c=>{return !skipNames.includes(c.name)})
    }
    return config
  }

  displaySettings = () => {
//     cl("display settings")
//     cl(this.props)
    let config = this.settingsInfo[this.props.parms.settingsType]||[]
    if (this.isHydroRoot) {
      let st = this.props.parms.settingsType
      cl(st)
      if (st && st.indexOf("sensor") === 0) {
        config = config.filter(c => c.name !== "Setpoints")
      }
      if (st === "mapping") {
        config = config.filter(c => !["Vent Position Sensor Mappings","Mixing Tanks"].includes(c.name))
      }
      if (st === "calibration") {
        config = config.filter(c => c.name !== "Vent Position Sensor Calibration")
      }
      if (st === "equipment1800" || st === "equipment1900") {
        const blockedNames = ["Stages","Hum/DeHum","iDoser","Retractable Greenhouse","Smart Cool","Drive to Average","Influence Factors"]
        const blockedUrls = [
          "temp_Staging","HumDeHum","zone_Hum_DeHum","zone_Smartcool",
          "zone_SP_Drive_to_Avg","zone_SP_Influence_Factors","zone_SP_Retractable_Greenhouse","idoser"
        ]
        config = config.filter(c => !(blockedNames.includes(c.name) || blockedUrls.some(u => (c.url||"").indexOf(u) >= 0)))
      }
      if (st === "zone_configuration") {
        const blockedNames = ["Stage Settings","Deadband Settings","Alarm Limits","Simple Setup","Peristaltic","Lighting","Fallback Settings","Heat and Cool Demand"]
        const blockedUrls = ["zone_Stages","zone_Deadband","zone_Alarms","zone_Simple","zone_Peristaltic","zone_Lighting","zone_Fallback","zone_H-C_Demand"]
        config = config.filter(c => !(blockedNames.includes(c.name) || blockedUrls.some(u => (c.url||"").indexOf(u) >= 0)))
      }
    }
    if(this.props.parms.settingsType=="mapping"){
      let is1800=hasGatewayType1800("zones", this.props.parms.zone)
      config=config.filter(c=>c.gwType==((is1800)?1800:1900))
//       if(hasGatewayType1800("zones", this.props.parms.zone)){
//         config=config.filter(c=>c.gwType==1800)
// //         config=config.filter(c=>!["Sensor Mapping","Input Config"].includes(c.name))
//       } else { // if pearl
//         config=config.filter(c=>c.gwType==1900)
// //         config=config.filter(c=>!["Basic Mapping"].includes(c.name))
//       }
    }
    if(acctFeature("zoneGroups")){
      config=this.removeForGroups(config)
    }
    if(this.props.parms.settingsType=="account"){
//       cl("account settings")
      if(!privs("account",0,constant.AREA_PRIVS_ADMIN)){
        config=[]
//         config=[
//           {name: "Manage Site Access", mode: "usa", url: "/usa/c18/admin/manageSiteAccess2"},
//         ]
      }
    }
//     cl(config)
//     cl("display")
    let lines=config.map((e, i) => {
//       cl(e)
      return(
        <C18Anchor00 id={e.url} to="" key={i} className="button outlined" onClick={(ev)=>this.settingsClick(ev,e.mode,e.url)}>{e.name}</C18Anchor00>
      )
    })
    return (
        <div className="button-list">
        {lines}
        </div>
    )
  }
  
  onChange=(type,vals)=>{
//     cl(type,vals)
    switch(type){
      case "cont":
        this.setState(vals)
        vals.cmd="selController"

        this.props.parms.onChange(vals)
        break
    }
    
  }
  
  showControllerSelect=()=>{
//     cl("show")
    let options=[{v:0,t:"Base Controller"}]
//     cl(this.zoneControllers)
    this.zoneControllers.forEach((c,i)=>{
      if(i&&(+c)){options.push({v:i,t:`Expansion ${i}`})}
    })
    return(
        <C18CustomSelect01 parms={{
          id:"contSel",
          title:"Controller Select",
          value:this.props.parms.selController,
          onChange:e=>this.onChange("cont",{selController:e.currentTarget.value}),
          options:options,
        }}/>
    )
    
  }
  
  render(){
//     cl("render settings")
//     cl(this.state)
//     cl(this.props)
    let controllerPage=["sensor1800","mapping","calibration",].includes(
      this.props.parms.settingsType)
//     cl(this.zoneControllers)
    let cnt=0
    if(this.zoneControllers){this.zoneControllers.forEach(c=>{cnt+=c})}
    
//     if(this.state.isLoadingSettings){
//       return <LoadingSpinner message="loading settings..." />
//     }
    
    if(this.state.loaded){
      return(
        <div id={this.props.parms.settingsType}>
        {(controllerPage&&(cnt>1))&&
          this.showControllerSelect()
        }
          {this.displaySettings()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading settings..." />
    }
  }
}

// this.settingsInfo={
//   sensor:[
//     {name: "Input Mapping", type: "settings", url: "/mapping"}.
//     /*other lines*/
//     {name: "Input Multipliers", type: "fui", url: "/fui/unit_Input_Multipliers"}.
//   ],
// 	
// }

      
export default C18Settings00;
